import createIcon from '../../createIcon';

/**
 * @component @name FolderOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNjU0NyA1LjI5NDUzSDEyLjY1NDdMMTAuNjU0NyAzLjI5NDUzSDcuNDg0NzNMMjIuNDE0NyAxOC4yMjQ1QzIyLjU2NDcgMTcuOTQ0NSAyMi42NTQ3IDE3LjYzNDUgMjIuNjU0NyAxNy4yOTQ1VjcuMjk0NTNDMjIuNjU0NyA2LjE5NDUzIDIxLjc1NDcgNS4yOTQ1MyAyMC42NTQ3IDUuMjk0NTNaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMi43NTQ3MyAxLjM5NDUzTDEuMzQ0NzMgMi44MDQ1M0wyLjkwNDczIDQuMzY0NTNDMi43NTQ3MyA0LjY0NDUzIDIuNjY0NzMgNC45NTQ1MyAyLjY2NDczIDUuMjk0NTNMMi42NTQ3MyAxNy4yOTQ1QzIuNjU0NzMgMTguMzk0NSAzLjU1NDczIDE5LjI5NDUgNC42NTQ3MyAxOS4yOTQ1SDE3LjgyNDdMMjEuMTM0NyAyMi42MDQ1TDIyLjU0NDcgMjEuMTk0NUwyLjc1NDczIDEuMzk0NTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FolderOff = createIcon('FolderOff', [
  [
    'path',
    {
      d: 'M20.6547 5.29453H12.6547L10.6547 3.29453H7.48473L22.4147 18.2245C22.5647 17.9445 22.6547 17.6345 22.6547 17.2945V7.29453C22.6547 6.19453 21.7547 5.29453 20.6547 5.29453Z',
      key: '1wsfhm',
    },
  ],
  [
    'path',
    {
      d: 'M2.75473 1.39453L1.34473 2.80453L2.90473 4.36453C2.75473 4.64453 2.66473 4.95453 2.66473 5.29453L2.65473 17.2945C2.65473 18.3945 3.55473 19.2945 4.65473 19.2945H17.8247L21.1347 22.6045L22.5447 21.1945L2.75473 1.39453Z',
      key: 'qgfkzd',
    },
  ],
]);

export default FolderOff;
